import { render, staticRenderFns } from "./SfTabs.vue?vue&type=template&id=5a2cd795&"
import script from "./SfTabs.vue?vue&type=script&lang=js&"
export * from "./SfTabs.vue?vue&type=script&lang=js&"
import style0 from "./SfTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports